import { GoabButton, GoabIconButton, GoabButtonGroup } from "@abgov/react-components";
import { DynamicFields } from "../Forms/DynamicFields";
import { evaluate } from '../../../utils/globalUtility';
import { handleGA } from "../../../utils/analytics";
import { useAnalyticsStep } from "../../../utils/useAnalyticsStep";

const parseFunction = (funcString) => {
    try {
        return eval(funcString); // Convert the string to an executable arrow function
    } catch (error) {
        console.error('Error parsing function from JSON', error);
        return () => {}; // Return empty function if parsing fails
    }
};

const parseArgument = (arg) => {
    const trimmedArg = arg.trim().replace(/^['"]|['"]$/g, ""); // Trim spaces before processing
    
    if (trimmedArg === "true") return true;
    if (trimmedArg === "false") return false;
    if (!isNaN(trimmedArg) && trimmedArg !== "") return Number(trimmedArg);
    if (trimmedArg === "null") return null;
    if (trimmedArg === "undefined") return undefined;
    return trimmedArg; // Return as string if no match
};

export const DynamicButton = ({ field, form, getResourceValue, context, clickHandlers }) => {
    
    const { onClick, label, disabled, ...otherProps } = field.properties;
    const [handlerName, ...args] = onClick?.split(/\(|,|\)/)?.filter(Boolean).map((arg) => parseArgument(arg)); // Parse and trim arguments;
    let content = getResourceValue({ key: 'RESOURCES@' + label });

    let isDisabled = false;
    if (disabled) {
        isDisabled = evaluate(disabled, {...context, form: form});
    }


    const currentStep = useAnalyticsStep();

    const handleButtonClick = () => {
        // 1. Trigger GA - Pass the field object as handleGA expects
        handleGA(field, currentStep);

        // 2. original dynamic logic
        if (clickHandlers && clickHandlers?.[handlerName]) {
            clickHandlers[handlerName](...args);
        } else if (onClick) {
            parseFunction(onClick);
        }
    };

    return (
        <GoabButton 
            onClick={handleButtonClick}
            disabled={isDisabled} 
            {...otherProps}>
                {content}
        </GoabButton>
    );
};

export const DynamicIconButton = ({ field, form, getResourceValue, context, clickHandlers }) => {
    const parseFunction = (funcString) => {
        try {
            return eval(funcString); // Convert the string to an executable arrow function
        } catch (error) {
            console.error('Error parsing function from JSON', error);
            return () => {}; // Return empty function if parsing fails
        }
    };

    const { onClick, disabled, ...otherProps } = field.properties;
    const [handlerName, ...args] = onClick?.split(/\(|,|\)/)?.filter(Boolean).map((arg) => parseArgument(arg)); // Parse and trim arguments;

    let isDisabled = false;
    if (disabled) {
        isDisabled = evaluate(disabled, {...context, form: form});
    }

    return (
        <GoabIconButton _click={() => clickHandlers && clickHandlers?.[handlerName] ? clickHandlers?.[handlerName](...args) : parseFunction(onClick)} disabled={isDisabled} {...otherProps}></GoabIconButton>
    );
};

export const DynamicButtonGroup = ({ field, form, getResourceValue, context, clickHandlers, setFormData }) => {
    return (
      <GoabButtonGroup {...field.properties}> 
          <DynamicFields children={field.fields} form={form} getResourceValue={getResourceValue} context={context} clickHandlers={clickHandlers} setFormData={setFormData}></DynamicFields>
      </GoabButtonGroup>
    );
};